import EarthIntroduction from "../../components/ClassThree/SocialStudies/EarthIntroduction";
import EnvironmentIntroduction from "../../components/ClassThree/SocialStudies/EnvironmentIntroduction";
import IndiaHeritage from "../../components/ClassThree/SocialStudies/IndiaHeritage";
import IndianFestival from "../../components/ClassThree/SocialStudies/IndianFestival";
import SafetyRules from "../../components/ClassThree/SocialStudies/SafetyRules";
import TimeCalender from "../../components/ClassThree/SocialStudies/TimeCalender";
import TransportChanges from "../../components/ClassThree/SocialStudies/TransportChanges";
import CommunityHelpers from "../../components/ClassThree/SocialStudies/CommunityHelpers";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-three/social-studies/changes-in-transport", title: "Changes in Transport", component: TransportChanges },
    { url: "/class-three/social-studies/time-and-calender", title: "Time & Calender", component: TimeCalender },
    { url: "/class-three/social-studies/community-helping-each-other", title: "Community: Helping Each Other", component: CommunityHelpers },
    { url: "/class-three/social-studies/india-land-of-rich-heritage", title: "India – A Land of Rich Heritage", component: IndiaHeritage },
    //{ url: "/class-three/social-studies/indian-festival-culture", title: "Indian – Festival & Culture", component: IndianFestival },
    { url: "/class-three/social-studies/safety-rules", title: "Safety Rules", component: SafetyRules },
    { url: "/class-three/social-studies/the-earth-an-introduction", title: "The Earth – An Introduction", component: EarthIntroduction },
    { url: "/class-three/social-studies/the-environment-an-introduction", title: "The Environment – An Introduction", component: EnvironmentIntroduction },
];


export default topics;